import { render, staticRenderFns } from "./CmgDualPromoBanner.vue?vue&type=template&id=1af990e6&scoped=true&lang=pug&"
import script from "./cmg-dual-promo-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-dual-promo-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgDualPromoBanner.vue?vue&type=style&index=0&id=1af990e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af990e6",
  null
  
)

export default component.exports